export interface CoachProfileType {
  id: string;
  title: string;
  tags?: string;
  description?: string;
  imageLink: string;
  videoLink?: string;
  status: string;
  sortOrder?: number;
  countries?: string;
  options?: any;
}

export interface FormCoachProfileType {
  title: string;
  imageLink: string;
  countries?: string;
  tags?: string;
  description?: string;
  options?: any;
}

export interface PlayerProfileType {
  id: string;
  title: string;
  widgetId?: string;
  headshot?: string;
  imageLink: string;
  videoLink?: string;
  status: string;
  sortOrder?: number;
  countries?: string;
  options?: any;
}

export enum CoachProfileStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum LinkType {
  WEB_LINK = 'WEB_LINK',
  DEEP_LINK = 'DEEP_LINK',
  CMS = 'CMS',
}

export interface SetDisabledTypePrams {
  disabled: boolean;
}

export interface SortCoachProfilesPayload {
  sortOrderList: {
    id: string;
    sortOrder: number;
  }[];
}
